import React from "react";
import BaseEdge, { roundedOrthPath } from "./BaseEdge";

// Connects to the *nearest side* of each node — like MaxGraph PERIMETER routing.
function perimeterAnchor(node, targetPos) {
  const cx = node.x + node.width / 2;
  const cy = node.y + node.height / 2;

  const dx = targetPos.x - cx;
  const dy = targetPos.y - cy;

  // Select nearest side
  if (Math.abs(dx) > Math.abs(dy)) {
    // Hit left or right
    return {
      x: dx > 0 ? node.x + node.width : node.x,
      y: cy,
    };
  }

  // Hit top or bottom
  return {
    x: cx,
    y: dy > 0 ? node.y + node.height : node.y,
  };
}

export default function PerimeterEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  edgeControls,
  color,
}) {
  const fromNode = nodeById[edge.from];
  const toNode = nodeById[edge.to];
  if (!fromNode || !toNode) return null;

  // Anchor on nearest side of each node
  const src = perimeterAnchor(fromNode, {
    x: toNode.x + toNode.width / 2,
    y: toNode.y + toNode.height / 2,
  });

  const dst = perimeterAnchor(toNode, {
    x: fromNode.x + fromNode.width / 2,
    y: fromNode.y + fromNode.height / 2,
  });

  const ctrl = edgeControls?.[edgeIndex];

  const midX = Math.round((src.x + dst.x) / 2);
  const cp1 = ctrl?.cp1 ?? { x: midX, y: src.y };
  const cp2 = ctrl?.cp2 ?? { x: midX, y: dst.y };

  const pts = [src, cp1, cp2, dst];
  const d = roundedOrthPath(pts);

  const labelPos = {
    x: (cp1.x + cp2.x) / 2,
    y: (src.y + dst.y) / 2 - 12,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
